<template>
  <div :class="$style.pricingFaq">
    <HeadingLarge
      :class="$style.title"
      :hasMargin="false"
      weight="semibold"
    >
      FAQs
    </HeadingLarge>
    <Grid
      :class="$style.faqGrid"
    >
      <GridItem
        v-for="faq in faqs"
        :key="faq.question"
        :class="$style.singleFaq"
        :gridSpan="6"
      >
        <HeadingSmall
          :class="$style.question"
          weight="bold"
        >
          {{ faq.question }}
        </HeadingSmall>
        <ParagraphBody>
          {{ faq.answer }}
          <ExternalLink
            v-if="faq.externalLink"
            :href="faq.externalLink.href"
            :text="faq.externalLink.text"
            @click="handleExternalLinkClicked(faq)"
          />
        </ParagraphBody>
      </GridItem>
    </Grid>
  </div>
</template>

<script>
import {
  Grid,
  GridItem,
  HeadingLarge,
  HeadingSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ExternalLink from 'components/ExternalLink.vue';
import PricingFaqConstants from 'client/Pricing/PricingFaqConstants';

const {
  description,
  location,
  section,
  text,
  toUrl,
} = eventProperties;

const {
  pricingPage,
} = eventLocations;

export default {
  name: 'PricingFaq',

  EventHelper,

  components: {
    ExternalLink,
    Grid,
    GridItem,
    HeadingLarge,
    HeadingSmall,
    ParagraphBody,
  },

  computed: {
    faqs() {
      return PricingFaqConstants.faqs;
    },
  },

  methods: {
    handleExternalLinkClicked(faq) {
      this.$options.EventHelper.triggerLinkClicked({
        [description]: 'opens KB article in a new tab',
        [location]: pricingPage,
        [section]: 'Pricing FAQs',
        [text]: faq.externalLink.text,
        [toUrl]: faq.externalLink.href,
      });
    },
  },
};
</script>

<style module scoped>
.pricingFaq .faqGrid {
  row-gap: 3rem;
}

.question {
  min-height: 3rem;
}

.pricingFaq .title {
  margin-bottom: 3.5rem;
}

.singleFaq {
  padding: 0 3rem;
  text-align: left;
}
</style>
